var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.20169C0 2.42947 0.270278 1.79241 0.810811 1.29049C1.35134 0.788555 2.05406 0.537598 2.91892 0.537598C3.76835 0.537598 4.45559 0.784686 4.9807 1.27891C5.52123 1.78856 5.79151 2.45264 5.79151 3.27119C5.79151 4.0125 5.52897 4.63025 5.00386 5.12447C4.46333 5.63412 3.7529 5.88895 2.87259 5.88895H2.84942C1.99999 5.88895 1.31275 5.63412 0.787645 5.12447C0.262541 4.61482 0 3.97388 0 3.20169ZM0.301158 23.472V7.99706H5.44402V23.472H0.301158ZM8.29344 23.472H13.4363V14.831C13.4363 14.2905 13.4981 13.8735 13.6216 13.5801C13.8378 13.055 14.166 12.6109 14.6062 12.248C15.0463 11.8851 15.5984 11.7036 16.2626 11.7036C17.9923 11.7036 18.8571 12.8696 18.8571 15.2017V23.472H24V14.5994C24 12.3137 23.4595 10.5801 22.3784 9.3986C21.2973 8.21713 19.8687 7.6264 18.0927 7.6264C16.1004 7.6264 14.5483 8.48354 13.4363 10.1978V10.2442H13.4131L13.4363 10.1978V7.99706H8.29344C8.32432 8.49126 8.33977 10.0279 8.33977 12.6071C8.33977 15.1862 8.32432 18.8079 8.29344 23.472Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.ccf9b5b1b9d282147e7e70d52a996b5f.svg";
export { ForwardRef as ReactComponent };